export const afterSalesStateEnum = [
    {
        stateId: "REFUND_PENDING_UNSHIPPED", // 1
        stateName: "未发货退款待处理"
    },
    // {
    //     stateId: 2,
    //     stateName: "已发货退货/退款待处理"
    // },
    // {
    //     stateId: 3,
    //     stateName: "换货待处理"
    // },
    // {
    //     stateId: 4,
    //     stateName: "补寄待处理"
    // },
    // {
    //     stateId: 5,
    //     stateName: "待买家退货"
    // },
    // {
    //     stateId: 6,
    //     stateName: "待商家验收"
    // },
    // {
    //     stateId: 7,
    //     stateName: "待买家收货"
    // },
    // {
    //     stateId: 8,
    //     stateName: "待平台处理"
    // },
    {
        stateId: "BUYER_CANCELLED", // 10
        stateName: "买家撤销"
    },
    {
        stateId: "SUCCESS", // 11
        stateName: "售后完成"
    },
    {
        stateId: "FAILED", // 12
        stateName: "售后结束"
    },
    // {
    //     stateId: 13,
    //     stateName: "售后结束(商品超时未寄回)"
    // },
    // {
    //     stateId: 14,
    //     stateName: "售后结束(商家退回商品)"
    // },
]

